import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { extractDateFromIsoDate } from '@functional';
import { FONT_SIZES } from '~/assets/styles/base';

type DateItemProps = {
  dataTestId: string;

  item?: string | number;
};

const DateItem: React.FC<DateItemProps> = ({ item = '', dataTestId }): JSX.Element => (
  <Box
    sx={{
      display: 'inline',
      fontSize: FONT_SIZES.body1,
      m: '5px',
    }}
    data-testid={`uiParts-DeliveryDateArea-${dataTestId}`}
  >
    {item}
  </Box>
);

type DeliveryDateAreaProps = {
  isoDeliveryDate: string;
};

const DeliveryDateArea: React.FC<DeliveryDateAreaProps> = ({ isoDeliveryDate }): JSX.Element => {
  const { t } = useTranslation();

  const getDate = extractDateFromIsoDate(isoDeliveryDate);

  return (
    <Typography component="div" data-testid="uiParts-DeliveryDateArea">
      <DateItem dataTestId="year" item={getDate.year} />
      <DateItem dataTestId="yearSuffix" item={t('appCommon.yearSuffix')} />
      <DateItem dataTestId="month" item={getDate.month} />
      <DateItem dataTestId="monthSuffix" item={t('appCommon.monthSuffix')} />
      <DateItem dataTestId="date" item={getDate.dt} />
      <DateItem dataTestId="dateSuffix" item={t('appCommon.dateSuffix')} />
      <DateItem dataTestId="day" item={`(${getDate.weekday})`} />
      <DateItem dataTestId="space" />
      <DateItem dataTestId="hour" item={getDate.hour} />
      <DateItem dataTestId="hourSuffix" item={t('appCommon.hourSuffix')} />
      <DateItem dataTestId="minute" item={getDate.minute} />
      <DateItem dataTestId="minuteSuffix" item={t('appCommon.minuteSuffix')} />
    </Typography>
  );
};

export default DeliveryDateArea;
